import { NavBtn as e } from "../styles.mjs";
import "react";
import { useTranslation as t } from "@maat/store-i18n";
import { jsx as n } from "react/jsx-runtime";
import { ChevronLeft as r, ChevronRight as i } from "lucide-react";
//#region src/components/FullscreenGallery/components/GalleryNavButton.tsx
var a = ({ direction: a, disabled: o, onClick: s }) => {
	let { t: c } = t("ds");
	if (o) return null;
	let l = a === "prev" ? r : i;
	return /* @__PURE__ */ n(e, {
		$side: a === "prev" ? "left" : "right",
		onClick: (e) => {
			e.stopPropagation(), s();
		},
		"aria-label": c(a === "prev" ? "ds:gallery.prevImage" : "ds:gallery.nextImage"),
		children: /* @__PURE__ */ n(l, { size: 24 })
	});
};
//#endregion
export { a as GalleryNavButton };
